module.exports = __webpack_public_path__ + "static/img/banner1.a048899.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/banner1.jpg
// module id = kTB6
// module chunks = 1